import { reactive } from 'vue';

export const criarPlaExpedicaoItem = () => {
    return reactive({
        id: 0,
        idplaexpedicao: 0,
        idprodutomapa: 0,
        dtexpedicao: '',
        nfnro: 0,
        nmcomercial: '',
        qtd: 0,
        unidade: '',
        lote: '',
        comprador_nome: '',
        comprador_cpfcnpj: '',
        comprador_nmmunicipio: '',
        nmresponsavel: '',
        idlogin: 0,
        idusuario: 0
    });
};